import Vue from "vue";

// axios
import axios from "axios";
import router from "@/router";
const apiKey = process.env.VUE_APP_BASE_URL;
const AUTHTOKEN = localStorage.getItem("accessToken" || "token");
const locale = localStorage.getItem("updatedLocal" || "lang");
const axiosIns = axios.create({
  baseURL: apiKey,
  headers: {
    Authorization: `Bearer ${AUTHTOKEN}`,
    "x-locale": locale ? locale : "en",
    "X-Page-Size": "all",
  },
});

Vue.prototype.$http = axiosIns;

axiosIns.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (401 === error.response.status) {
      // handle go to login
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("userData");

      router.push({ name: "login" });
    } else {
      return Promise.reject(error);
    }
  }
);

export default axiosIns;
